import { SiteAdminClinicInfoFormTemplate } from '@/components/templates';
import { useAdminClinicInfoCreate } from '@/hooks/admin/useAdminClinicInfoCreate';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { ClinicCreateFormData, flattenClinicCreateData } from './clinicFormSchema';

const SiteAdminClinicInfoCreatePage = () => {
  const { site } = useParams<{ site: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const clinic_id = searchParams.get('clinic_id');
  const currentSite = site ?? 'medix';

  const { mutateAsync: createClinicInfo, isPending } = useAdminClinicInfoCreate();
  const queryClient = useQueryClient();

  const breadcrumbItems = [
    {
      title: '治療院詳細',
      href: clinic_id
        ? `/${currentSite}/admin/clinics/${clinic_id}`
        : `/${currentSite}/admin/clinics`,
    },
    {
      title: '新規',
    },
  ];

  const handleSubmit = async (data: ClinicCreateFormData) => {
    const flattenedData = flattenClinicCreateData(data);
    const finalClinicId = String(data.clinicInfo.clinic_id || clinic_id);
    await createClinicInfo({
      siteType: currentSite,
      data: {
        ...flattenedData,
        clinic_id: finalClinicId,
      },
    });
    queryClient.invalidateQueries({ queryKey: ['clinic-detail', finalClinicId, currentSite] });
    navigate(`/${currentSite}/admin/clinics/${finalClinicId}`);
  };

  return (
    <main>
      <SiteAdminClinicInfoFormTemplate
        breadcrumbItems={breadcrumbItems}
        onSubmit={handleSubmit}
        isLoading={isPending}
        clinicId={clinic_id || undefined}
        site={currentSite}
      />
    </main>
  );
};

export default SiteAdminClinicInfoCreatePage;
